import { Component, OnInit } from '@angular/core';
import { ModalController, PickerController } from '@ionic/angular';
import moment, { Moment } from 'moment';
import Order from 'src/smoothr-web-app-core/models/Order';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { getSlotsByOrder, isVenueOpen, sleep } from 'src/smoothr-web-app-core/utils/utils';
import { SelectionTimeType } from '../select-time-slot-dialog/select-time-slot-dialog.component';
import { TimeUtils } from 'src/smoothr-web-app-core/utils/time-utils';
import { TranslateService } from '@ngx-translate/core';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
	selector: 'app-before-create-order-select-time-dialog',
	templateUrl: './before-create-order-select-time-dialog.component.html',
	styleUrls: ['./before-create-order-select-time-dialog.component.scss'],
})
export class BeforeCreateOrderSelectTimeDialogComponent implements OnInit {
	public order: Order;
	public venue: Venue;
	public selectionTimeTypeEnum = SelectionTimeType;
	public selectedTimeType: SelectionTimeType = SelectionTimeType.LATER;
	public slots: Moment[] = [];
	public dates: Moment[] = [];
	public maxDates = 7;
	public slot: Moment;
	public TimeUtils = TimeUtils;
	public now: moment.Moment;
	public showDates: boolean = false;
	public showTime: boolean = false;
	public timeSelected: Moment;
	public loading = false;
	public isOpeningTimeSheet: boolean = false;
	public selectedTime: Moment = null;
	public preorderType: PreorderType;
	public isAsap = false;
	public isAsapAvailable = false;
	public isVenueClosed = false;
	public formControlTime = new FormControl();
	public testForm: FormGroup;
	public isOpenRestaurant: boolean = true;
	mapslot: Moment;
	constructor(
		private modalCtrl: ModalController,

		public translate: TranslateService,
		private pickerCtrl: PickerController,
		private fb: FormBuilder
	) {}

	ngOnInit() {
		this.mapslot = moment(this.order.orderAt);
		this.checkIfAsapExist();
		console.log(this.order);
		if (this.order.orderAt) {
			this.patchValue(this.order.orderAt);
		}
		this.formControlTime.valueChanges.subscribe(v => {
			this.selectedTime = v;
		});
	}
	public patchValue(value) {
		this.formControlTime.patchValue(moment(this.order.orderAt), { emitEvent: true });
		this.selectedTime = value;
	}
	public pushSlot(value) {
		return moment(value);
	}
	private checkIfAsapExist() {
		let venueOpen = false;
		try {
			venueOpen = isVenueOpen(this.venue);
		} catch (e) {}
		this.isVenueClosed = !venueOpen;
		this.isAsapAvailable = false;
		this.loadSlots();
	}
	static async show(
		modalCtrl: ModalController,
		order: Order,
		venue: Venue,
		preorderType: PreorderType,
		isOpenRestaurant: boolean = false
	): Promise<{ asap: boolean; slot: Moment } | null> {
		const modal = await modalCtrl.create({
			component: BeforeCreateOrderSelectTimeDialogComponent,
			cssClass: ['auto-height', 'time-dialog'],
			componentProps: {
				venue,
				order,
				preorderType,
				isOpenRestaurant,
			},
			showBackdrop: true,
		});
		await modal.present();
		await sleep(100);
		const result = (await modal.onDidDismiss()).data;
		return result;
	}
	async loadSlots() {
		try {
			this.loading = true;
			let slots = (await getSlotsByOrder(this.venue, this.order)).map(slot => moment(slot.time));

			if ((slots.length === 1 && !slots[0]) || slots.length < 1) {
				this.isOpeningTimeSheet = false;
				this.loading = false;
				this.modalCtrl.dismiss(null);
				return;
			}
			this.slots = slots;
			if (this.slots.length > 0 && !this.order.orderAt) {
				this.patchValue(this.slots[0]);
			}
			if (moment(this.order.orderAt).isBefore(moment())) {
				this.patchValue(this.slots[0]);
			}
			this.loading = false;
			console.log('slots', this.slots);
		} catch (e) {
			this.loading = false;
		}
	}
	async openTimeSheet() {
		if (this.isOpeningTimeSheet) {
			return;
		}
		this.isOpeningTimeSheet = true;
		try {
			let slots = this.slots;
			if ((slots.length === 1 && !slots[0]) || slots.length < 1) {
				this.isOpeningTimeSheet = false;
				this.loading = false;
				this.modalCtrl.dismiss(null);
				return;
			}

			let dates: Moment[] = [];
			let isOpenRestaurant = false;
			try {
				isOpenRestaurant = isVenueOpen(this.venue);
			} catch (e) {}
			const slotsForToday = slots.filter(it => {
				const insertedDate = dates.find(date => TimeUtils.isSameDate(date, it));
				if (!insertedDate) {
					dates.push(it);
				}
				if (isOpenRestaurant) {
					return moment(it).isSame(moment(), 'day');
				} else {
					return moment(it).isSame(slots[0], 'day');
				}
			});

			let slotsMap = slotsForToday.map(slot => {
				return {
					text: this.slotToText(slot ? moment(slot) : null),
					value: slot,
				};
			});

			let daysMap = dates.map(slot => {
				return {
					text: moment().isSame(moment(slot), 'day') ? 'Today' : moment(slot).format('dddd'),
					value: slot,
				};
			});
			// if (isOpenRestaurant) {
			// 	daysMap.unshift({ text: 'ASAP', value: null });
			// 	slotsMap = [];
			// }

			const options = {
				cssClass: 'picker-time',
				title: 'Оберіть час',
				message: 'Будь ласка, виберіть день і слот',
				columns: [
					{
						name: 'day',
						class: 'time-picker',
						options: daysMap,
					},
					{
						name: 'slot',
						class: 'time-picker',
						options: slotsMap,
					},
				],
				buttons: [
					{
						text: this.translate.instant('tip_component.custom_picker.cancel'),
						role: 'cancel',
						handler: () => {
							this.isOpeningTimeSheet = false;
						},
					},
					{
						text: this.translate.instant('tip_component.custom_picker.confirm'),
						handler: value => {
							console.log('value', value);
							this.isAsap = false;
							this.isOpeningTimeSheet = false;

							if (value.day.text === 'ASAP') {
								this.selectedTime = null;
								this.isAsap = true;
								return;
							}

							const dayValue = moment(value.day.value).format('YYYY-MM-DD');
							const setTime = moment(value.slot.value).format('HH:mm');
							const finalTime = moment(dayValue + ' ' + setTime);
							this.selectedTime = finalTime;
						},
					},
				],
			};
			const picker = await this.pickerCtrl.create(options);
			await picker.present();

			picker.columns[0].selectedIndex = 0;
			picker.addEventListener('ionPickerColChange', async (event: any) => {
				if (event.detail.name === 'day') {
					const selectedDay = daysMap[event.detail.selectedIndex];
					const foundSlotsForThisDay = slots.filter(slot => moment(selectedDay.value).isSame(moment(slot), 'd'));
					let newMappedSlots = foundSlotsForThisDay.map(slot => {
						return {
							text: this.slotToText(slot ? moment(slot) : null),
							value: slot,
						};
					});

					const timeColumn = await picker.getColumn('slot');
					timeColumn.options = newMappedSlots;
					timeColumn.selectedIndex = 0;
					picker.columns[1] = timeColumn;
					picker.columns = JSON.parse(JSON.stringify(picker.columns));
				}
			});
		} catch (e) {
			console.error(e);
		}
		this.isOpeningTimeSheet = false;
		this.loading = false;
	}
	slotToText(slot: Moment): string {
		const now = moment();
		const sameDay = slot.dayOfYear() === now.dayOfYear() && slot.year() === now.year();
		if (sameDay) {
			return slot.format('HH:mm');
		} else {
			return slot.format('HH:mm');
		}
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
	showTimeValue(time?: Moment) {
		if (time) {
			const m = moment(time).locale(this.translate.currentLang);
			if (TimeUtils.isSameDate(m, moment())) {
				return this.translate.instant('common.today') + ', ' + m.format('HH:mm');
			}
			return m.format('dd DD.MM., HH:mm');
		}
		if (this.isAsap) {
			return 'ASAP - Today';
		}
	}
	selectTime() {
		console.log('beofre crete ------', this.formControlTime.value);
		if (this.formControlTime.value) {
			this.modalCtrl.dismiss({ slot: this.selectedTime });
		}
		// if (this.isAsap) {
		// 	this.modalCtrl.dismiss({ asap: this.isAsap });
		// }
		// if (this.selectedTime) {
		// 	this.modalCtrl.dismiss({ slot: this.selectedTime });
		// }
	}
}
